import { Avatar } from "shared/components/atoms/Avatar";
import { User } from "shared/models/index";
import { css } from "twin.macro";

interface Props {
  users: User[];
  salesQuantity: number;
  className?: string;
}

export const CustomerHistory = (props: Props) => {
  const { className } = props;
  const users = props.users.slice(0, 5);
  return (
    <div tw="relative flex items-center" className={className}>
      {users.map((user, index) => (
        <div
          key={index}
          tw="absolute border border-solid border-[#fff] rounded-full"
          css={css({ left: index * 14 })}
        >
          <Avatar src={user.imageUrl} size={25} blur={2} />
        </div>
      ))}
      <p tw="font-base font-normal text-xs leading-[19px] tracking-[.3px] text-theme ml-auto">
        {props.salesQuantity}名が鑑定を申し込んでいます
      </p>
    </div>
  );
};
